import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="bg-trust text-white py-14 md:py-20 px-4 text-center" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6 font-heading" data-id="element-48">
          Tu tranquilidad y la relación con tu hijo valen mucho más que $6.36
        </h2>
        <p className="text-base md:text-xl text-white/90 mb-8 md:mb-10 font-light" data-id="element-49">
          No dejes que otra cena termine en discusión. Da el primer paso hoy
          para recuperar la paz en tu hogar.
        </p>
        <CTAButton className="bg-white text-trust hover:bg-primary hover:text-trust shadow-xl" showIcon={false} data-id="element-50">
          Descargar la guía ahora
        </CTAButton>
      </div>
    </section>;
}